"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _axios = _interopRequireDefault(require("axios"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _this = this;
    return {
      pageName: 'sfeLoginLog',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        loginInStyle: '',
        loginCode: '',
        empNo: '',
        startTime: '',
        endTime: ''
      },
      lookupList: {},
      startPickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        },
        selectableRange: '00:00:00 - 23:59:59'
      },
      endPickerOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.searchVal.startTime) {
            return time.getTime() <= new Date(_this.searchVal.startTime).getTime() - 3600 * 1000 * 24;
          }
        },
        selectableRange: '00:00:00 - 23:59:59'
      }
    };
  },
  computed: {
    startTime: function startTime() {
      return this.searchVal.startTime;
    }
  },
  watch: {
    startTime: function startTime(nval, oval) {
      var date = new Date(nval);
      var hours = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      this.endPickerOptions.selectableRange = "".concat(hours, ":").concat(minute, ":").concat(second, " - 23:59:59");
    },
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode();
    }
  },
  mounted: function mounted() {
    this.getLookupTypeCode();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          loginInStyle: this.searchVal.loginInStyle,
          loginCode: this.searchVal.loginCode,
          empNo: this.searchVal.empNo,
          startTime: this.searchVal.startTime,
          endTime: this.searchVal.endTime
        }
      };
      this.listLoading = true;
      this.$api.loginLog.getList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this3 = this;
      var param = {
        configItemCodeList: ['LOGINLOG_STATUS']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        _this3.lookupList = JSON.parse(JSON.stringify(res.data || {}));
        // 查找值数据转换
        for (var key in _this3.lookupList) {
          _this3.generateMapping(key, _this3.lookupList[key] || []);
        }
        _this3.searchData();
      }).catch(function () {
        console.log('Data Request Fail');
      });
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this4 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this4.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    },
    resetData: function resetData() {
      this.searchVal = {
        loginInStyle: '',
        loginCode: '',
        empNo: '',
        startTime: '',
        endTime: ''
      };
      this.fetchData();
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    downloadExcel: function downloadExcel(name) {
      var _this5 = this;
      var param = {
        startTime: this.searchVal.startTime,
        endTime: this.searchVal.endTime
      };
      this.isLoading = true;
      this.$api.loginLog.export(param).then(function (res) {
        _this5.isLoading = false;
        (0, _index.downloadFileExcel)(name, res.data);
      }).catch(function () {
        _this5.isLoading = false;
      });
    }
  }
};